<template>
  <div class="editor">
    <div style="border: 1px solid #ccc">
      <div id="editor" ref="editor"></div>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
import oss from '@/api/base/api-upload'

export default {
  name: 'editor',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [Number],
      default: 0,
    },
  },
  data () {
    return {
      editor: null,
      html: '',
      toolbarConfig: {
        excludeKeys: ['video'],
        // insertKeys: {
        //   index: 2,
        //   keys: ['divider']
        // }
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          // 自定义上传图片
          uploadImage: {
            customUpload: this.update,
          },
          uploadVideo: {
            customUpload: this.update,
          },
        },
      },
      mode: 'default', // or 'simple'
      first: true,
    }
  },
  watch: {
    value (nv) {
      if (this.editor.txt.html() !== nv) {
        this.editor.txt.html(nv)
      }
    },
  },
  methods: {
    init () {
      // this.editor = new E('#editor')
      this.editor = new E(this.$refs.editor)
      this.editor.config.fontSizes = {
        'x-small': { name: '10px', value: '1' },
        'small': { name: '13px', value: '2' },
        'normal': { name: '16px', value: '3' },
        'large': { name: '18px', value: '4' },
        'x-large': { name: '24px', value: '5' },
        'xx-large': { name: '32px', value: '6' },
        'xxx-large': { name: '48px', value: '7' },
      }
      const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } = E
      // 第一，菜单 class ，Button 菜单继承 BtnMenu class
      class dashedMenu extends BtnMenu {
        constructor(editor) {
          // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
          const $elem = E.$(
            `<div class="w-e-menu" data-title="虚线分割线">
              <i class="el-icon-s-operation" />
            </div>`
          )
          super($elem, editor)
        }
        // 菜单点击事件
        clickHandler () {
          // 做任何你想做的事情
          // 可参考【常用 API】文档，来操作编辑器

          // alert('hello world')
          this.editor.cmd.do(
            'insertHTML',
            '<hr style="border: none; border-bottom: 1px dashed #000; display: block;"></hr> <br />'
          )
          // this.editor.cmd.do('insertHTML', '<p></p>')
        }
        // 菜单是否被激活（如果不需要，这个函数可以空着）
        // 1. 激活是什么？光标放在一段加粗、下划线的文本时，菜单栏里的 B 和 U 被激活，如下图
        // 2. 什么时候执行这个函数？每次编辑器区域的选区变化（如鼠标操作、键盘操作等），都会触发各个菜单的 tryChangeActive 函数，重新计算菜单的激活状态
        tryChangeActive () {
          // 激活菜单
          // 1. 菜单 DOM 节点会增加一个 .w-e-active 的 css class
          // 2. this.this.isActive === true
          // this.active()
          // // 取消激活菜单
          // // 1. 菜单 DOM 节点会删掉 .w-e-active
          // // 2. this.this.isActive === false
          // this.unActive()
        }
      }
      const menuKey = 'dashedMenuKey'

      // 第一，菜单 class ，Button 菜单继承 BtnMenu class
      class AlertMenu extends DropListMenu {
        constructor(editor) {
          // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
          const $elem = $(
            '<div class="w-e-menu" data-title="首行缩进"><i class="w-e-icon-indent-increase"></i></div>'
          )
          // droplist 配置
          const dropListConf = {
            width: 100,
            title: '首行缩进',
            type: 'list',
            list: [
              {
                $elem: $(
                  '<p><i class="w-e-icon-indent-increase w-e-drop-list-item"></i>增加缩进</p>'
                ),
                value: '2em',
              },
              {
                $elem: $(
                  '<p><i class="w-e-icon-indent-decrease w-e-drop-list-item"></i>减少缩进</p>'
                ),
                value: '',
              },
            ],
            // droplist 每个 item 的点击事件
            clickHandler: (value) => {
              // value 参数即 dropListConf.list 中配置的 value
              this.command(value)
            },
          }
          super($elem, editor, dropListConf)
        }

        command (value) {
          // 设置标题
          // 判断是否有子元素 有一个官方提供的结束节点不准确的Bug
          if (
            this.editor.selection.getSelectionContainerElem().elems[0].children
              .length > 0
          ) {
            // 无格式文本父元素是p，要把第一行单独拿出来缩进
            let fir = 0
            // 判断是否进入选区
            var start = false
            // 提前算出<br>标签的个数
            let isAllBr = 0
            // 判断是否全部是<br> 即无格式文本
            let isVali = false
            // 提前算出<br>标签的个数
            for (let e of this.editor.selection.getSelectionContainerElem()
              .elems[0].children) {
              if (e.tagName === 'BR') {
                isAllBr++
              }
            }
            // 如果选区内子元素的个数与<br>元素个数相同即可判断为无格式文本
            if (
              isAllBr ===
              this.editor.selection.getSelectionContainerElem().elems[0]
                .children.length
            )
              isVali = true
            // 对无格式文本进行缩进处理
            if (isVali) {
              for (let e of this.editor.selection.getSelectionContainerElem()
                .elems[0].children) {
                if (e.tagName === 'BR') {
                  if (value === '2em') {
                    fir += 1
                    if (fir === 1) {
                      this.editor.selection.getSelectionContainerElem().elems[0].style.textIndent =
                        value
                    }
                    // 先把<br>换成span元素并增加缩进 再在span元素前再加上<br> indentP是因为原来用的是P元素
                    const indentP = document.createElement('span')
                    indentP.style.display = 'inline-block'
                    indentP.style.width = value
                    indentP.className = 'indentP'
                    const theBr = document.createElement('br')
                    this.editor.selection
                      .getSelectionContainerElem()
                      .elems[0].replaceChild(indentP, e)
                    this.editor.selection
                      .getSelectionContainerElem()
                      .elems[0].insertBefore(theBr, indentP)
                  }
                }
              }
            } else {
              let elseIndex = 0
              // 正常文本 以及无格式文本取消缩进逻辑
              for (let e of this.editor.selection.getSelectionContainerElem()
                .elems[0].children) {
                // 如果是无格式文本
                if (e.className === 'indentP') {
                  elseIndex++
                  if (elseIndex === 1) {
                    this.editor.selection.getSelectionContainerElem().elems[0].style.textIndent =
                      value
                  }
                  this.editor.selection
                    .getSelectionContainerElem()
                    .elems[0].removeChild(e)
                  continue
                }
                // 如果是普通文本 选区的开始节点
                if (
                  e === this.editor.selection.getSelectionStartElem().elems[0]
                ) {
                  start = true
                }
                // 如果已是选中节点，则开始进行缩进
                if (start) {
                  e.style.textIndent = value
                }
                // 选区的结束节点 跳出循环
                if (
                  e === this.editor.selection.getSelectionEndElem().elems[0]
                ) {
                  break
                }
              }
            }
          } else {
            this.editor.selection.getSelectionContainerElem().elems[0].style.textIndent =
              value
          }
        }

        // 删除这段代码会报错
        tryChangeActive () {
          // const reg = /^h/i
          // const cmdValue = this.editor.cmd.queryCommandValue('indent')
          // if (reg.test(cmdValue)) {
          //     // 选区处于标题内，激活菜单
          //     this.active()
          // } else {
          //     // 否则，取消激活
          //     this.unActive()
          // }
          // this.active()
        }
      }
      const menuKey1 = 'alertMenuKey'
      this.createEditor([menuKey, menuKey1], [dashedMenu, AlertMenu])
    },
    reset(){
      this.editor.txt.clear()
    },
    createEditor (menuKey, dashedMenu) {
      menuKey.forEach((item, i) => {
        this.editor.menus.extend(item, dashedMenu[i])
        this.editor.config.menus = this.editor.config.menus.concat(item)
      })
      this.editor.config.excludeMenus = ['indent']
      this.editor.config.showLinkImg = false
      this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
        resultFiles.forEach((file) => {
          this.update(file, insertImgFn)
        })
      }
      this.editor.create()
      this.editor.config.onchange = (html) => {
        this.$emit('input', html)
        this.$emit('getText', this.editor.txt.html())
      }
      this.editor.txt.html(this.value)
    },
    async update (file, insertFn) {
      this.loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      oss(file, 0, 'public/activity').then(({ url }) => {
        this.loading.close()
        insertFn(url)
      }).catch(() => {
        this.$Message.warning('获取链接失败')
        this.loading.close()
      })
    },
    onChange (editor) {
      if (this.first) {
        this.first = false
        return
      }
      this.$emit('input', this.html)
    },
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.editor {
  font[size="1"] {
    font-size: 10px;
  }
  font[size="2"] {
    font-size: 13px;
  }
  font[size="3"] {
    font-size: 16px;
  }
  font[size="4"] {
    font-size: 18px;
  }
  font[size="5"] {
    font-size: 24px;
  }
  font[size="6"] {
    font-size: 32px;
  }
  font[size="7"] {
    font-size: 48px;
  }
}
</style>
